import { NavigationGuard } from 'vue-router';
import { StorageKeys } from '../../services/local-storage';
import { CustomerModule } from '../../store/CustomerModule';
import { WarrenSession } from '../../services/session';
import { getDomainAndPlatform } from '../../helpers/onboarding/getDomainAndPlatform';

export const redirectToOnboardingSignIn: NavigationGuard = async (
  _to,
  _from,
  next
) => {
  logOffUser();
  const { domain, platform } = getDomainAndPlatform();

  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');
  const currentQueryParams =
    queryIndex !== -1
      ? new URLSearchParams(hash.substring(queryIndex))
      : new URLSearchParams();

  const redirectUrl = `/onboarding/${domain}/${platform}`;
  const queryString = currentQueryParams.toString();
  const finalUrl = queryString ? `${redirectUrl}?${queryString}` : redirectUrl;

  window.location.href = finalUrl;
};

function logOffUser() {
  CustomerModule.resetCustomer();
  CustomerModule.resetAccountStatus();
  const keysToPreserve = [
    StorageKeys.AccessToken,
    StorageKeys.RefreshToken,
    StorageKeys.Theme,
    StorageKeys.DarkMode,
    StorageKeys.LastPartnerDashRoute,
    StorageKeys.PartnerShowMoney,
    StorageKeys.PartnerDashNewsInformation,
    StorageKeys.PartnerProfileNewsInformation,
    StorageKeys.PartnerStatementNewsInformation,
    StorageKeys.PartnerPortfolioNewsInformation,
    StorageKeys.NewPartnerFeaturesViewed,
    StorageKeys.ShowedPortfoliosTemplateTutorial,
    StorageKeys.HasDownloadedFeeStatement,
    StorageKeys.HasUsedPositionDetailsButton
  ];

  WarrenSession.clean(keysToPreserve);
}
